import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { getUsers } from "../../../../../core/api/services/userlist.service";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import UserListTableComponent from "./user-list-table.component";

const UserListComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const [userlistSearchValue, setUserlistSearchValue] = useState("");
  const pageSize = 10;

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("profileName"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const {
    data: users,
    isLoading: isLoadingUser,
    refetch,
  } = useQuery({
    queryKey: [
      "getLocationSites",
      PageNumber,
      SortBy,
      SortDirection,
      userlistSearchValue,
    ],
    queryFn: ({ signal }) =>
      getUsers(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        userlistSearchValue,
        signal
      ),
  });

  const [columns, setColumns] = useState([
    {
      title: "User Name",
      label: "profileName",
      isSorted: true,
    },
    // {
    //   title: "User ID",
    //   label: "UserId",
    //   renderProps: (data: any) => {
    //     return <div>{data?.email || data?.userId}</div>;
    //   },
    // },
    {
      title: "Role",
      label: "roleName",
    },
  ]);

  const onRefetchData = () => {
    if (users?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNum(1);
    setUserlistSearchValue(searchVal);
  }, []);

  return (
    <div>
      <UserListTableComponent
        columns={columns}
        data={users?.data}
        totalNumberOfRecords={users?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        onSearch={handleSearch}
        isLoading={isLoadingUser}
      />
    </div>
  );
};

export default UserListComponent;
